<template>
  <v-card>
    <v-card-title class="headline primary white--text" dark primary-title>
      {{ $t('participant.muter.title') }}
    </v-card-title>

    <div row class="ma-2 pa-3">
      <v-layout row mb-5>
        <v-flex md11>
          <p>{{ $t('participant.muter.message') }}</p>
        </v-flex>
      </v-layout>
      <v-layout row mb-5>
        <v-flex md11 ml-5>
          <datasource-dropdown
            :datasource="etablissementsEntrepriseInsee"
            search="raisonSociale"
            field="raisonSociale"
            :label="$t('participant.muter.etablissementDestination')"
            :value="etablissementDestination.etablissementRemplacant"
            @input="etablissementDestination.etablissementRemplacant = $event"
            prepend-icon="mdi-domain"
          />
        </v-flex>
      </v-layout>
      <v-layout row mb-5 v-if="bilanEnCours == true">
        <v-flex md12>
          <v-checkbox
            v-model="etablissementDestination.priseEnChargeBilanEnCours"
            :label="$t('participant.muter.priseEnChargeBilanEnCours')"
            color="primary"
          />
        </v-flex>
      </v-layout>
    </div>

    <v-divider />

    <v-card-actions>
      <v-btn
        @click="$emit('muter')"
        dark
        color="green"
        :disabled="etablissementDestination.etablissementRemplacant == null"
        >{{ $t('participant.muter.action') }}</v-btn
      >
      <v-btn @click="$emit('close')">{{ $t('button.cancel') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    etablissementDestination: {
      type: Object,
    },
    etablissementsEntrepriseInsee: {
      type: Object,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    bilanEnCours: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.etablissementDestination.etablissementRemplacant = null
      }
    },
  },
}
</script>
